import React from 'react'

type OutcomeProps = {
    outcome: string,
    reo: boolean
}

const Outcome = ({ outcome, reo }: OutcomeProps) => {

    let feedback;

    if (outcome === 'auē') {
            feedback = reo ? 'Auē, kua raru tā tātou whatarangi. Taihoa e whakamātau anō.' : 'Aroha mai, we encountered an issue. Try again later.';
    } else {
        feedback = reo ? 'He nui rawa āu tono mai... Hei te 10m ka taea te tuku īmēra anō.' : "You're adding quite a few addresses... You can add some more in ten minutes time!";
    }

    return <p className='py-2 px-3 shadow-xl rounded-sm bg-toto-0 text-kaho-1 fadeFloat z-99'>{feedback}</p>

}

export default Outcome
